export default __webpack_public_path__ + "static/media/Memory-Expansion.95170649.png";